import { render, staticRenderFns } from "./pageFooter.vue?vue&type=template&id=5d11d07b&scoped=true&"
import script from "./pageFooter.vue?vue&type=script&lang=js&"
export * from "./pageFooter.vue?vue&type=script&lang=js&"
import style0 from "./pageFooter.vue?vue&type=style&index=0&id=5d11d07b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../RetirementPlanner.Demo/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d11d07b",
  null
  
)

export default component.exports